<template>
  <div class="container">
    <div class="container-fluid p-0 card_background_effect">
      <div class="row justify-content-center" v-if="!isCandidateOtpVerified">
        <div class="col-12 col-md-4 card card-with-shadow border-0 centered-container">

       <h5 class="text-center">
         {{companyInfo.company_name}}
       </h5>
          <div v-if="companyInfo.logo">

          <img :src="companyInfo.logo" alt="LOGO" class="width-300 mb-5 d-block mx-auto">
      </div>

          <form class="mb-0"
                :class="{ 'loading-opacity': preloader }"
                ref="form"
                :data-url="emailVerificationURL"
                method="post"
                @submit.prevent="submitForm">
            <div class="form-row">
              <div class="form-group">
                <h6 class="text-center mb-0">
                  Password Less Login
                </h6>
                <span class="typewriter">{{ originalText }}</span>
              </div>
            </div>
            <div class="form-group row align-items-center" v-if="!email_sent">
              <label class="col-sm-2 mb-sm-0">Email</label>
              <app-input class="col-sm-8"
                         type="email"
                         v-model="email"
                         placeholder="Email Address"/>
            </div>
            <div class="form-group row align-items-center" v-if="email_sent">
              <label class="col-sm-2 mb-sm-0">OTP</label>
              <app-input class="col-sm-8"
                         type="text"
                         v-model="otp"
                         placeholder="OTP"/>
            </div>
            <div class="form-group text-center">
              <el-button class="btn btn-primary mr-2"
                         @click.prevent="submitForm">
                {{ email_sent ? 'Verify OTP' : 'Get OTP' }}
              </el-button>
            </div>
            <div class="form-group text-center" v-if="showRequestAgain">
              <el-button class="btn btn-primary mr-2"
                         @click.prevent="requestOtpAgain">
              </el-button>
            </div>
          </form>
        </div>
      </div>
      <div class="row" v-if="isCandidateOtpVerified">
        <candidate-registration :configData="configDataProps" :companyInfo="companyInfo" :applicant="applicant" />
      </div>
    </div>

  </div>
</template>

<script>
import {FormMixin} from '../../../../core/mixins/form/FormMixin.js';
import {SCREENING_USER_EMAIL_VERIFICATION_REQUEST} from "../../../Config/ScreeningAppUrl.js";
import CandidateRegistration from "@Views/Screening/CandidateRegistration/CandidateRegistration";

export default {
  name: "CandidateEmailVerification",
  mixins: [FormMixin],
  components: {CandidateRegistration},
  data() {
    return {
      originalText: "Welcome to Passwordless Entry! Experience a hassle-free login with our new Passwordless Entry feature. No need to remember passwords anymore – simply enter your email address, and we'll send you a one-time verification code. Just check your email, enter the code, and you're in! It's quick, secure, and eliminates the need for complex passwords.",
      typewriterText: "",
      otp: '',
      email: '',
      email_sent: false,
      requestOtpAgain: false,
      showRequestAgain: false,
      emailVerificationURL: SCREENING_USER_EMAIL_VERIFICATION_REQUEST,
      preloader: false,
      isCandidateOtpVerified: false,
      configDataProps: {},
      companyInfo: {},
      applicant: {},
    };
  },
  created() {
    this.companyInfo = this.$attrs['companydata-prop'];
    this.configDataProps = this.$attrs['config-data'];
    const emailProps = this.$attrs['email-prop'];
    const companyProps = this.$attrs['company-prop'];
    if ((emailProps) && (companyProps)) {
      localStorage.setItem('candidate-email', emailProps);
      this.isCandidateOtpVerified = true;
      return;
    }
    const _email = localStorage.getItem('candidate-email');
    if (_email) {
      this.isCandidateOtpVerified = true;
    }
  },
  methods: {
    submitForm() {
      let otp = this.otp;
      let email = this.email;
      let email_sent = this.email_sent;
      if (!this.email_sent) {
        if (!this.validateEmail(email)) {
          this.$toastr.e("Please enter valid email address.");
          return;
        }
        this.save({otp, email, email_sent});
        setTimeout(function () {
          this.requestOtpAgain = true;
          this.email_sent = false;
        }, 3000);
        return;
      } else {
        if (otp === '') {
          this.$toastr.e('Please enter otp code.');
          return;
        }
        this.save({otp, email, email_sent})
      }
    },
    beforeSubmit() {
      this.preloader = true;
    },
    afterSuccess(response) {

      this.preloader = false;
      this.$toastr.s(response.data.message);
      this.email_sent = true
      if (response.data.status) {

        localStorage.setItem('candidate-email', this.email);
        this.isCandidateOtpVerified = true;
      }if (response.data.applicant) {
        this.applicant = response.data.applicant;
      }
    },
    afterFinalResponse() {
      this.preloader = false;
    },
    afterError(response) {
      console.error("Error caught", response);
      // this.$toastr.e(response.response.data.message);
      this.preloader = false;
    },
    typeWriter() {
      let i = 0;
      const speed = 50; // Adjust speed as needed
      const timer = setInterval(() => {
        if (i < this.originalText.length) {
          this.typewriterText += this.originalText.charAt(i);
          i++;
        } else {
          clearInterval(timer);
        }
      }, speed);
    },
    validateEmail(email) {
      return String(email)
          .toLowerCase()
          .match(
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
    }
  }
};
</script>
<style>
.centered-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.typewriter {
  font-size: 1rem;
  margin-top: 3px;
  display: inline-block;
  overflow: hidden; /* Ensures that text doesn't overflow */
  border-right: 0.08em solid #333; /* Cursor effect */
  white-space: pre-wrap; /* Allow the text to wrap to the next line */
  letter-spacing: 0.15em; /* Adjust spacing between characters */
  animation: typing 3.5s steps(40, end); /* Adjust duration as needed */
}

</style>